
// Side-scrolling
function sideScroll(){
    const innerWrapper = document.getElementById('scrollInner');
    const buttonLeft = document.getElementById('slideLeft');
    const buttonRight = document.getElementById('slideRight');

    buttonLeft.onclick = function (e) {
        e.preventDefault();
        innerWrapper.scrollBy(-200, 0);
    };

    buttonRight.onclick = function (e) {
        e.preventDefault();
        innerWrapper.scrollBy(200, 0);
    };
}

sideScroll();


// Category Number
function categoryNum(){
  const scrollInner = document.getElementById('scrollInner');
	const categoryItem = document.querySelectorAll('#scrollInner .collection-category');
	const itemLength = categoryItem.length;

	if(itemLength > 3) {
		scrollInner.classList.add('greater-categories');
	}
}

categoryNum();